import React from "react";
import ReactDOM from "react-dom";
import { GlobalStyle } from "./global-style";
import App from "./App";
import { Provider } from "react-redux";
import store from "store/store";
import { checkVersion } from "./utils/versionCheck";

// 开发时报错浮层是全屏 iframe，会挡住点击，调试时先藏掉。
if (process.env.NODE_ENV === "development") {
  const style = document.createElement("style");
  style.textContent =
    "iframe{display:none!important;pointer-events:none!important;}";
  document.head.appendChild(style);
}

// 检查版本
checkVersion();

var fun = function (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      //这里是假设在375px宽度设计稿的情况下，1rem = 100px；
      //可以根据实际需要修改
      docEl.style.fontSize = 100 * (clientWidth / 375) + "px";
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
};
fun(document, window);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle whiteColor />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
